import { BUY_URL } from "./constants";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-navy pb-28 pt-14 text-cream/60" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 lg:flex-row lg:items-start lg:justify-between lg:px-10">
      <div className="max-w-sm">
        <a href="#top" className="inline-flex" data-testid="footer-logo-link" aria-label="Back to top">
          <img src="/civility-partners-logo.png" alt="Civility Partners" className="h-12 w-auto" />
        </a>
        <p className="mt-5 text-sm leading-relaxed">
          Transforming toxicity into trust. The Building a Speak-Up Culture™
          Train-the-Trainer Toolkit — a white-label workplace civility training program
          you can brand, deliver, and reuse without limits.
        </p>
      </div>
      <nav className="flex flex-col gap-3 text-sm" aria-label="Footer">
        <a href="#inside" data-testid="footer-link-inside" className="transition-colors duration-200 hover:text-terra">What's Inside</a>
        <a href="#value" data-testid="footer-link-value" className="transition-colors duration-200 hover:text-terra">The Value</a>
        <a href="#who" data-testid="footer-link-who" className="transition-colors duration-200 hover:text-terra">Who It's For</a>
        <a href="#faq" data-testid="footer-link-faq" className="transition-colors duration-200 hover:text-terra">FAQ</a>
        <a href={BUY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-buy-link" className="font-semibold text-terra transition-colors duration-200 hover:text-cream">
          Buy the Toolkit — $249
        </a>
      </nav>
    </div>
    <div className="mx-auto mt-12 max-w-7xl border-t border-white/10 px-6 pt-8 text-xs lg:px-10">
      <p>© {new Date().getFullYear()} Civility Partners. All rights reserved. All trademarks are the property of their respective owners.</p>
    </div>
  </footer>
);
